/**
 * no operation
 */
export function noop() {}